import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import {
    isValidPhoneNumber,
    parsePhoneNumberWithError,
} from 'libphonenumber-js';
import { prependCanadaAndUSCountryCode } from '../../../utils/prepend-country-code';

export function phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value || control.value.trim() === '') {
            return null; // Valid state if the field is empty (optional field)
        }

        try {
            const phoneNumber: string = prependCanadaAndUSCountryCode(
                control.value,
            );
            parsePhoneNumberWithError(phoneNumber);
            if (!isValidPhoneNumber(phoneNumber)) {
                return { phoneNumber: 'not a valid number' };
            }
            return null;
        } catch (error: any) {
            return { phoneNumber: error.message };
        }
    };
}
